var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5271 10.856L12.7696 12.0985L14.6246 10.2347L16.4796 12.0985L17.7221 10.856L15.8584 9.00098L17.7221 7.14598L16.4796 5.90348L14.6246 7.76723L12.7696 5.90348L11.5271 7.14598L13.3909 9.00098L11.5271 10.856ZM11.0984 5.16848C11.0021 3.99598 9.8821 2.84973 8.4996 2.87598C7.0121 2.91098 5.8746 4.01348 5.8746 5.50098C5.8746 6.98848 7.0121 8.07348 8.4996 8.12598C8.84085 8.12598 9.17335 8.05598 9.4971 7.92473C9.73335 6.96223 10.1271 6.05223 11.0984 5.16848ZM9.3746 9.00098H4.1246C4.1246 8.03848 3.3371 7.25098 2.3746 7.25098V3.75098C3.3371 3.75098 4.1246 2.96348 4.1246 2.00098H12.8746C12.8746 2.96348 13.6621 3.75098 14.6246 3.75098V3.79473C15.2109 3.80348 15.7971 3.90848 16.3746 4.10098V0.250977H0.624603V10.751H9.6546C9.4621 10.1647 9.3746 9.57848 9.3746 9.00098Z",
    fill: "#FF5E43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon34);
export default __webpack_public_path__ + "static/media/icon34.34519a7fa6dee7edccc9e2986eeff81d.svg";
export { ForwardRef as ReactComponent };